import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';

const Code = ({ children }: PropsWithChildren) => {
  return (
    <Box component="code" sx={{ whiteSpace: 'pre', backgroundColor: theme => theme.palette.grey.A200 }}>
      {children}
    </Box>
  );
};

export { Code };
